import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../contexts/ThemeContext';
import { theme } from '../../theme';

const ToggleContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${theme.borderRadius.full};
  border: 1px solid ${({ theme: { isDark } }) =>
        isDark ? theme.colors.dark.border.light : theme.colors.light.border.medium};
  background: ${({ theme: { isDark } }) =>
        isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
  backdrop-filter: blur(10px);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${({ theme: { isDark } }) =>
        isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'};
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.lg};
  }

  &:active {
    transform: translateY(0);
  }
`;

const Icon = styled.div<{ isDark: boolean }>`
  font-size: 20px;
  transition: all 0.3s ease;
  transform: ${({ isDark }) => isDark ? 'rotate(180deg)' : 'rotate(0deg)'};
  opacity: ${({ isDark }) => isDark ? 0.8 : 1};
`;

const ThemeToggle: React.FC = () => {
    const { toggleTheme, isDark } = useTheme();

    return (
        <ToggleContainer onClick={toggleTheme} title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
            <Icon isDark={isDark}>
                {isDark ? '🌙' : '☀️'}
            </Icon>
        </ToggleContainer>
    );
};

export default ThemeToggle;







